import type { DemoAgent } from "@/lib/app-types";

const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";
const URB = "var(--font-urbanist), sans-serif";

interface WorkingProgressProps {
  agent: DemoAgent;
  progress: number;
  status: string;
}

export default function WorkingProgress({ agent, progress, status }: WorkingProgressProps) {
  return (
    <div
      className="desktop-glass-card"
      style={{
        width: "100%",
        background: "#1E1E1E",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 16,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        gap: 14,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            className="app-loading-pulse"
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: agent.avatarBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <span style={{ fontFamily: PJK, fontWeight: 700, fontSize: 14, color: "#fff" }}>
              {agent.avatarInitials}
            </span>
          </div>
          <span style={{ fontFamily: PJK, fontWeight: 600, fontSize: 15, color: "#F2F0ED" }}>
            {agent.name} is working…
          </span>
        </div>
        <span style={{ fontFamily: URB, fontWeight: 700, fontSize: 14, color: "#8635F6" }}>
          {progress}%
        </span>
      </div>

      <div
        style={{
          width: "100%",
          height: 6,
          borderRadius: 9999,
          background: "#2D2C2C",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            background: "#8635F6",
            boxShadow: "0 0 12px rgba(134,53,246,0.45)",
            transition: "width 250ms ease-out",
          }}
        />
      </div>

      <div
        key={status}
        className="app-anim-fade-up"
        style={{
          fontFamily: URB,
          fontWeight: 500,
          fontSize: 13,
          lineHeight: "18px",
          color: "rgba(242,240,237,0.6)",
          minHeight: 18,
        }}
      >
        {status || "Starting…"}
      </div>
    </div>
  );
}
